import {post, get} from './http'
import ports from './ports'

let config = {
    headers: {'Content-Type': 'application/json'}
};
export default {
    account: {
        login: (params = {}) => {
            return post(ports.account.login, {}, params, config);
        }
    },
    material: {
        batchGetMaterial: (params) => {
            return get(ports.material.batchGetMaterial, params)
        },
        addMaterial: (params) => {
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data;boundary = ' + new Date().getTime()
                },
                // transformRequest: [function (data) {
                //     return data
                // }]
            };
            window.console.log(" ------ addMaterial " + params);
            return post(ports.material.addMaterial, params, {}, config);
        },
    },
    menu: {
        getMenus: () => {
            return get(ports.menu.menus);
        },
        createMenu: (body) => {
            return post(ports.menu.menu, body, {}, config)
        }
    },
    messageReply: {
        messages: (params) => {
            return get(ports.messageReply.messages, params);
        },
        addMessage: (body) => {
            return post(ports.messageReply.message, body, {}, config)
        },
        messageEnable:(body)=>{
            return post(ports.messageReply.messageEnable, body, {}, config)
        }
    }
};